import { z } from 'zod';
import { AuditMeta, TenantId } from '../common.js';
/**
 * A tenant is a licensed organisation. `suppohrt` is the platform owner;
 * each zorggroep (e.g. `rhogo`) is an additional tenant with scoped access.
 *
 * Firestore path: tenants/{tenantId}
 */
export const TenantSchema = AuditMeta.extend({
    id: TenantId,
    displayName: z.string().min(2).max(200),
    type: z.enum(['suppohrt', 'zorggroep']),
    status: z.enum(['active', 'suspended']),
    /**
     * Whether Ring 3 (unverified web fallback) is enabled for this tenant.
     * Default: false at launch. Per-tenant override lets us enable post-sign-off
     * without a global rollout.
     */
    ring3Enabled: z.boolean().default(false),
    /**
     * Branding override for zorggroep tenants. SUPPOHRT uses platform default.
     */
    branding: z
        .object({
        logoUrl: z.string().url().optional(),
        primaryColor: z
            .string()
            .regex(/^#[0-9a-fA-F]{6}$/)
            .optional(),
    })
        .optional(),
    /**
     * Conversation log retention in days. Default 90 (spec §10.1).
     */
    retentionDays: z.number().int().min(7).max(365).default(90),
});
/**
 * Payload for creating a new tenant. Strips server-assigned fields.
 */
export const CreateTenantInput = TenantSchema.omit({
    createdAt: true,
    createdBy: true,
    updatedAt: true,
    updatedBy: true,
    status: true,
}).extend({
    status: TenantSchema.shape.status.default('active'),
});
//# sourceMappingURL=tenant.js.map